import { selectPreferredName, useAppSelector } from '@core/core/store'
import type { SpaCustomParam, SpaEventId } from '@core/core/types'
import { defaultSpaEventType, sendSpaEvent } from '@core/core/utils'
import { useCallback } from 'react'

export const useSpa = () => {
  const login = useAppSelector(selectPreferredName)

  return useCallback(
    (
      componentId: SpaEventId,
      customParams: SpaCustomParam[] = [],
      component = 'OTHER',
      constEventType = 'click',
    ) => {
      if (!login) return

      const userIdParam = { as_user_id: true, value: login }

      sendSpaEvent(defaultSpaEventType, {
        componentid: componentId,
        constaeventtype: constEventType,
        component,
        customparams: [...customParams, userIdParam],
      })
    },
    [login],
  )
}
